import { render } from "./JoinPage.vue?vue&type=template&id=126a3bb8"
import script from "./JoinPage.vue?vue&type=script&lang=js"
export * from "./JoinPage.vue?vue&type=script&lang=js"

import "./JoinPage.vue?vue&type=style&index=0&id=126a3bb8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__